export default "__VITE_ASSET__58af0e7a__"